"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxAdditional = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Paragraph = require("../Paragraph/Paragraph");
/**
 * @extends Paragraph
 * @since 8.28.0
 */
var ComboboxAdditional = /*#__PURE__*/(0, _styledComponents.default)(_Paragraph.Paragraph).withConfig({
  displayName: "ComboboxAdditional",
  componentId: "c11n-8-107-0__sc-1gaarm6-0"
})([""]);
exports.ComboboxAdditional = ComboboxAdditional;
ComboboxAdditional.displayName = 'ComboboxAdditional';

/** @component */